import { render, staticRenderFns } from "./DocList.vue?vue&type=template&id=f13b5aec&scoped=true&"
import script from "./DocList.vue?vue&type=script&lang=js&"
export * from "./DocList.vue?vue&type=script&lang=js&"
import style0 from "./DocList.vue?vue&type=style&index=0&id=f13b5aec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13b5aec",
  null
  
)

export default component.exports